import { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface ScrollToTopProps {
  authFlow?: boolean;
}

const ScrollToTop: FC<ScrollToTopProps> = ({ authFlow = false }): null => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (authFlow) {
      const element = document.getElementById('root');
      if (element) {
        element.scrollTo(0, 0);
        const logoElement = document.getElementById('main-logo');
        logoElement && logoElement?.focus();
      }
    } else {
      const element = document.getElementById('main-wrapper');
      if (element) {
        element.scrollTo(0, 0);
        const headingElement = document.getElementById('mainContent');
        if (headingElement && headingElement?.tagName === 'H1') {
          headingElement.focus();
        } else {
          const logoElement = document.getElementById('main-logo');
          logoElement?.focus();
        }
      }
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
